/** Quota refusals must not suggest retrying the same exhausted download. */
export const isTemplateQuotaFailure = (error: unknown): boolean => {
  const failure = (error as { response?: { data?: { message?: string; errors?: { quota?: string[] }; data?: { quota?: string[] } } } })?.response?.data;
  const codes = [failure?.message, ...(failure?.errors?.quota || []), ...(failure?.data?.quota || [])].join(' ');
  return /dmp_quota_exhausted|dmp_positive_balance_required|dmp_insufficient_balance/.test(codes);
};
